import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

export const LANG_STORAGE_KEY = 'sahib-language';
export const SUPPORTED_LANGS = ['ar', 'en'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

// Resolves a namespace JSON to its on-disk location:
//   `common`            → src/locales/langs/<lang>/common.json
//   `<feature>` (e.g. `home`) → src/features/<feature>/locales/<lang>.json
async function loadNamespace(language: string, namespace: string) {
  if (namespace === 'common') {
    return import(`./langs/${language}/${namespace}.json`);
  }
  return import(`../features/${namespace}/locales/${language}.json`);
}

const initialized = i18n
  .use(resourcesToBackend(loadNamespace))
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ar',
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    defaultNS: 'common',
    ns: ['common'],
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: LANG_STORAGE_KEY,
    },
  });

// Tests can `await i18nReady` to ensure translations are loaded before render.
export { i18n, initialized as i18nReady };
